module.exports = __webpack_public_path__ + "img/360-image.4a982b80.png";